var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditStroke = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2497 2.9834C18.5393 2.9834 17.829 3.25271 17.2907 3.79129L8.52906 12.5521C8.36282 12.7184 8.24107 12.9251 8.17652 13.1521L7.00218 17.2642C6.97321 17.3659 6.97196 17.4736 6.99855 17.576C7.02514 17.6784 7.07861 17.7718 7.15341 17.8466C7.22822 17.9214 7.32166 17.9749 7.42406 18.0015C7.52646 18.0281 7.6341 18.0268 7.73585 17.9979L11.8488 16.8235L11.8495 16.8228C12.075 16.7579 12.2812 16.6377 12.4479 16.471L21.2088 7.70939C22.2859 6.63229 22.2859 4.8684 21.2088 3.79129C20.6704 3.25271 19.9601 2.9834 19.2497 2.9834ZM19.2497 4.16393C19.6538 4.16393 20.0573 4.31962 20.3684 4.63089C20.9918 5.25427 20.9925 6.24642 20.3692 6.8698L19.6015 7.63749L17.3626 5.39858L18.1303 4.63089C18.4414 4.31962 18.8456 4.16393 19.2497 4.16393ZM16.523 6.23817L18.7619 8.47708L11.6076 15.6314C11.5844 15.6544 11.555 15.6721 11.5217 15.6816L8.43706 16.563L9.3184 13.4775C9.32748 13.4456 9.3441 13.4163 9.36865 13.3917L16.523 6.23817Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13L7.5 17L8 17.5L12 16L20.5 7.5L21.5 5.5L20 3.5L18 4L9 13Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.5L16.5 4.5L16 5L20 9L20.5 8.5Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 3.08301H12.375H7.16667C4.86548 3.08301 3 4.94849 3 7.24967V17.6663C3 19.9675 4.86548 21.833 7.16667 21.833H17.5833C19.8845 21.833 21.75 19.9675 21.75 17.6663V11.4163V9.59342",
    stroke: "#828282",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditStroke);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-stroke.41eb7a86d5997db828a0ac7e005455d6.svg";